import "./styles.scss";
import React from "react";

export const CenterableImage: React.FC<typeof HTMLImageElement> = (props) => (
  <img className="CenterableImage" alt={props.alt} {...props} />
);
